/* eslint-disable camelcase */
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container, InputContainer, Map, Row, Title } from './styled'
import { Input } from '../../../../components/common/Input'
import { Button } from '../../../../components/common/Button'
import { Eye, MapPin } from '@phosphor-icons/react'
import MapOccurences from '../../../LatestRequests/components/MapOccurences'

export const UserStatus = ({ data }) => {
  const occurrence_status_json = {
    ABERTO: 'Aguardando ação',
    EMPROGRESSO: `Em ocorrência`,
    FECHADO: 'Fechado',
  }

  const {
    CreatedOccurrences,
    ClosedOccurrences,
    Occurrences,
    AlwaysAlertMessages,
  } = data

  const navigate = useNavigate()
  const [address, setAddress] = useState<boolean>(false)
  const verifyAddress = () => {
    if (AlwaysAlertMessages[0] && AlwaysAlertMessages[0].Location) {
      setAddress(true)
      return
    }
    alert('Sem localização de resposta')
  }

  const formatedData = (data) => {
    const date = data
    if (!date) {
      return ''
    }

    const fullDate = new Date(date)
    const hours = String(fullDate.getUTCHours()).padStart(2, '0')
    const minutes = String(fullDate.getUTCMinutes()).padStart(2, '0')

    return `${hours}:${minutes}`
  }

  return (
    <Container>
      <Row>
        <Input.Root>
          <Input.Label title="Nome do usuário" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content value={data.name} id="" disabled />
          </Input.Wrapper>
        </Input.Root>
      </Row>
      <Row>
        <Input.Root>
          <Input.Label title="Última ocorrência" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content
              value={
                (Occurrences[0] &&
                  `#${Occurrences[0].code} - ${Occurrences[0].type}`) ||
                ''
              }
              id=""
              disabled
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Status da ocorrência" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content
              value={
                (Occurrences[0] &&
                  occurrence_status_json[Occurrences[0].status]) ||
                ''
              }
              id=""
              disabled
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Horário de início" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content
              value={
                (Occurrences.length !== 0 &&
                  formatedData(Occurrences[0].created_at)) ||
                ''
              }
              id=""
              disabled
            />
          </Input.Wrapper>
        </Input.Root>
      </Row>
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Posto" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content value={data.outpost} id="" disabled />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Title>Acompanhamento de ocorrência</Title>

          <Button.Root
            backgroundColor="#00517D"
            onClick={() => navigate('/vigilancia/ultimas-ocorrencias')}
          >
            <Button.Content title="Ver em ocorrências" />
            <Button.Icon>
              <Eye size={20} color="#FFFFFF" weight="bold" />
            </Button.Icon>
          </Button.Root>
        </InputContainer>
      </Row>

      <Title>Retorno do sempre alerta</Title>
      <hr />

      <Row>
        <InputContainer>
          <Title>Status de retorno - alerta</Title>
          {AlwaysAlertMessages.length > 0 ? (
            <Button.Root
              backgroundColor={
                AlwaysAlertMessages.length > 0 ? '#00A324' : '#000'
              }
            >
              <Button.Content
                title={
                  AlwaysAlertMessages[0].answered_at ? 'Respondido' : 'Enviado'
                }
              />
            </Button.Root>
          ) : (
            <Button.Root backgroundColor={'#000'}>
              <Button.Content title={'Não enviado'} />
            </Button.Root>
          )}
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Data de envio do alerta" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                value={
                  AlwaysAlertMessages.length > 0
                    ? new Date(AlwaysAlertMessages[0].sent_at).toLocaleString()
                    : ''
                }
                id=""
                disabled
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Código encaminhado" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                value={
                  AlwaysAlertMessages.length > 0
                    ? AlwaysAlertMessages[0].code
                    : ''
                }
                id=""
                disabled
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>

      {AlwaysAlertMessages.length > 0 && (
        <>
          <Row>
            <Input.Root>
              <Input.Label title="Localização da resposta" htmlFor="" />
              <Input.Wrapper backgroundColor="">
                <Input.Content
                  value={AlwaysAlertMessages[0].answerLocation}
                  id=""
                  disabled
                />
              </Input.Wrapper>
            </Input.Root>
            <Map
              background={address ? '#BB0000' : '#fff'}
              border={address}
              onClick={verifyAddress}
            >
              <div>
                <MapPin
                  size={20}
                  color={address ? '#fff' : '#BB0000'}
                  weight="fill"
                />
              </div>
              <span>Ver no mapa</span>
            </Map>
          </Row>

          {address && (
            <>
              {AlwaysAlertMessages[0].Location && (
                <MapOccurences
                  answerLocation={AlwaysAlertMessages[0].Location}
                />
              )}
            </>
          )}
        </>
      )}

      <Title>Total de ocorrências</Title>
      <hr />

      <Row>
        <Input.Root>
          <Input.Label title="Total de ocorrências concluídas" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content
              value={`${ClosedOccurrences} ocorrências`}
              id=""
              disabled
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Total de ocorrências criadas" htmlFor="" />
          <Input.Wrapper backgroundColor="">
            <Input.Content
              value={`${CreatedOccurrences} ocorrências`}
              id=""
              disabled
            />
          </Input.Wrapper>
        </Input.Root>
      </Row>
    </Container>
  )
}
